export var mergeMaterials = function () {
    var materials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        materials[_i] = arguments[_i];
    }
    if (materials.length === 1) {
        return materials[0];
    }
    var mergedMaterials = materials.reduce(function (result, m) {
        Object.assign(result.components, m.components);
        Object.assign(result.plugins, m.plugins);
        Object.assign(result.actions, m.actions);
        return result;
    }, {
        components: {},
        plugins: {},
        actions: {},
    });
    return mergedMaterials;
};
//# sourceMappingURL=materials.js.map